// Generated by scripts/migrate/gen-from-live.py from https://www.dietz.eu/en/spring-coating/
// Source of truth is the LIVE page, not the original markdown scrape
// (which was incomplete: this content type was missed entirely, and
// several pages were captured as summaries rather than verbatim copy).
import type { PageEntry } from "@/content/schema";

export const springCoatingEN: PageEntry = {
  id: "post.federbeschichtung",
  locale: "en",
  slug: "spring-coating",
  seo: {
    title: "Glossary: Spring coating explained simply | Dietz GmbH",
    description: "Spring coating refers to the application of a special coating to the surface of a spring. These coatings are used to reduce friction, improve corrosion resistance or modify specifi",
  },
  type: "post",
  h1: "Glossary: Spring coating explained simply",
  intro: "Spring coating refers to the application of a special coating to the surface of a spring. These coatings are used to reduce friction, improve corrosion resistance or modify specific mechanical properties of the spring. The selection of the right spring coating depends on the environmental conditions, the requirements of the application and the material properties of the spring. A high-quality spring coating helps to extend the service life of the spring and optimise its performance.",
  blocks: [

  ],
};
